import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { Widowhood as WidowhoodVM } from 'mutation/view-models/registration-widowhood';
import ForeignStateList from 'shell/components/shared/foreign-state-list';
import { FormikTouched, FormikErrors } from 'formik';
import MunicipalityForeignList from 'shell/components/shared/municipality-foreign-list';
import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';

interface ForeignState {
  values?: WidowhoodVM | null;
  onChange: (key: keyof WidowhoodVM, value: WidowhoodVM[keyof WidowhoodVM]) => void;
  errors?: FormikErrors<WidowhoodVM>;
  touched?: FormikTouched<WidowhoodVM>;
}

const ForeignStateComponent = ({
  values,
  onChange,
  errors,
  touched,
}: ForeignState): React.ReactElement => {
  return (
    <Grid item container spacing={1}>
      <Grid item xs={12} md={4}>
        <ForeignStateList
          required
          value={values?.foreignState || null}
          onChange={(value) => onChange('foreignState', value)}
          label={'Stato estero'}
          id="foreignState"
          error={Boolean(errors?.foreignState) && touched?.foreignState}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <MunicipalityForeignList
          value={values?.foreignMunicipality || null}
          onChange={(value) => onChange('foreignMunicipality', value)}
          label="Comune estero"
          required
          id="foreignMunicipality"
          disabled={!values?.foreignState?.id}
          foreignStateIstatCode={values?.foreignState?.id}
          error={
            Boolean(errors?.foreignMunicipality as FormikErrors<MunicipalityAnprVM>) &&
            touched?.foreignMunicipality
          }
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Provincia o Contea"
          label="Provincia/Contea"
          id="foreignProvince"
          name="foreignProvince"
          fullWidth
          type="text"
          variant="outlined"
          onChange={(event) => onChange('foreignProvince', event?.target?.value)}
          value={values?.foreignProvince || ''}
          inputProps={{
            maxLength: '30',
          }}
        />
      </Grid>
    </Grid>
  );
};

ForeignStateComponent.displayName = 'Foreign State component';

const ForeignState = memo(ForeignStateComponent);

export default ForeignState;
